import { DraftConfiguration, VectorDesign } from '@/types';
import { getIsSpecialPatternColor } from './getIsSpecialPatternColor';
import { getPatternId } from './getPatternId';

export const getFillValue = (
  { cid: configurationId, printType, printColors }: DraftConfiguration,
  design?: VectorDesign,
  index = 0
) => {
  const fixedLayerIndex = design ? design.colors.findIndex((c) => c.layer === index) : index;
  if (getIsSpecialPatternColor(printType, printColors[fixedLayerIndex].id)) {
    return `url(#${getPatternId(configurationId, index)}`;
  }

  return printColors[fixedLayerIndex].fill;
};
